<template>
  <div class="app">
    <div class="app-header navbar p-1">
      <b-row  style="width: 100%">
        <b-col sm="2" class="text-center">
          <span v-html="svg.logo"></span>
        </b-col>
        <b-col sm="8" class="text-center">
          <h3 class="header-title">Medical Insurance Cards Processing using Document AI</h3>
        </b-col>
        <b-col sm="2">
          <b-navbar-nav style="flex-direction: column; padding-top: 10px;">
            <MicpHeaderAccount />
          </b-navbar-nav>
        </b-col>
      </b-row>
    </div>
    <div class="app-body">
      <div class="container-fluid p-0">
        <b-row class="m-0" style="width: 100%">
          <b-col class="col-sm-12 p-0">
            <b-card class="m-0" style="font-size: 16px">
              <b-row>
                <b-col offset-md="1" class="col-sm-12 col-md-10 text-center">
                  This solution processes insurance card images that are uploaded, and it extracts the data using Google Document AI. For demonstration purposes, we are processing / extracting limited fields. This solution can be extended to different types of inputs like driver licenses, large forms, invoices and more.
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="m-0" style="width: 100%">
          <b-col class="col-sm-12 col-md-8 p-0 pt-1 pr-1" style="height: 520px;">
            <b-card style="height: 100%">
              <b-card-body>
                <div style="height: 350px; overflow-y: scroll;">
                  <div class="p-3 text-center text-secondary">
                    <h4>Upload a scanned copy of insurance card to process</h4>
                    <h6>Note: Allowed formats are only pdf and image ( jpg, jpeg, png )</h6>
                  </div>
                  <div class="m-3">
                    <p class="text-danger upload-file-error" v-if="isDropzoneBlank">
                      <b>Please add a file.</b>
                    </p>
                    <vueDropzone ref="micpProcessDropZone"
                             id="dropzone" :class="currentState === 'upload' ? null : 'd-none'"
                             v-if="canShowDropZone"
                             :options="dropzoneOptions"
                             @vdropzone-file-added="onAddingFile"
                             v-on:vdropzone-sending="sendingEvent"
                             v-on:vdropzone-max-files-exceeded="onExceedingMaxFiles"
                             v-on:vdropzone-removed-file="onRemovingFile"
                             v-on:vdropzone-success="processResponse"
                             v-on:vdropzone-error="displayError">
                    </vueDropzone>
                    <b-row :class="currentState === 'processing' ? null : 'd-none'">
                      <b-col cols="12">
                        <b-card class="process-loading">
                          <content-placeholders>
                            <content-placeholders-img :style="{height: '150px'}" />
                          </content-placeholders>
                        </b-card>
                      </b-col>
                    </b-row>
                    <div class="p-3" v-if="currentState === 'processed'">
                      <img :src="imageUrl" class="processed-image">
                    </div>
                  </div>
                </div>
                <div class="text-center">
                  <b-button variant="secondary" class="upload-button"
                            @click="processFile" :disabled="!isUploadEnabled">
                    <i v-if="currentState === 'processing'"
                        class="fa fa-spinner fa-spin mr-2"
                        style="font-size:18px"></i>
                    {{buttonState}}
                  </b-button>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col class="col-sm-12 col-md-4 p-0 pt-1 pl-1" style="height: 520px;">
            <b-card style="height: 100%;">
              <b-card-header>
                <b-row>
                  <b-col class="col-10 pull-left">
                    <h5 >Results</h5>
                  </b-col>
                  <b-col class="col-2">
                    <b-button v-b-tooltip.hover title='Download JSON'
                              class="download-button" variant="secondary"
                              size="sm" :disabled="!isDownloadEnabled"
                              @click="downloadJSON">
                      <i class="fa fa-download"></i>
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-header>
              <b-card-body  class="process-results">
                <b-row v-for="(value, key) in processedResults" :key="key" class="processed-value">
                  <b-col class="col-4">
                    {{key | titlize}}
                  </b-col>
                  <b-col class="col-8">
                    : {{value}}
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
    <div>
      <footer class="app-footer d-flex footer-style">
        <b-row style="width: 100%">
          <b-col sm="2">
            <h5 class = "contact-us">Contact Us:</h5>
          </b-col>
          <b-col sm="8">
            <h5> <a class="mail-to" href="mailto:sureshr@wilcolabz.com">sureshr@wilcolabz.com</a> <br>4677 Old Ironsides Dr, Santa Clara, CA 95054</h5>
          </b-col>
        </b-row>
      </footer>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import svg from '../../_svg.js'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'
import { mapGetters } from 'vuex'
import MicpHeaderAccount from './micpHeaderAccount'

export default {
  name: 'micpDemo',
  components: {
    vueDropzone: vue2Dropzone,
    MicpHeaderAccount
  },
  data () {
    return {
      svg: svg,
      currentState: 'upload',
      isDropzoneBlank: false,
      isUploadEnabled: false,
      dropzoneOptions: {
        url: `${process.env.API_URL}/micp`,
        dictDefaultMessage: 'Click here / Drag and drop a file here to process',
        autoProcessQueue: false,
        thumbnailWidth: 100,
        thumbnailHeight: 100,
        parallelUploads: 1,
        maxFilesize: 10,
        maxFiles: 1,
        timeout: 300000,
        acceptedFiles: 'application/pdf, image/*',
        headers: { 'Authorization': '' },
        init: function () {
          this.on('addedfile', function (file) {
            file.previewElement.querySelector('.dz-details').style.backgroundColor = '#0b192d'
            var removeButton = document.createElement('div')
            removeButton.className = 'removeFormButton'
            removeButton.style.cssText = 'opacity:1;z-index:1000;position:absolute;top:5px;right:5px;color:white;'
            removeButton.innerHTML = '<i class="fa fa-trash"></i>'
            var _this = this
            removeButton.addEventListener('click', function (e) {
              e.preventDefault()
              e.stopPropagation()

              _this.removeFile(file)
            })
            file.previewElement.appendChild(removeButton)
          })
        }
      },
      results: {},
      processedResults: {
        'provider': '',
        'name': '',
        'id': '',
        'group number': '',
        'pcp': '',
        'pcp phone': '',
        'rxbin': '',
        'rxpcn': '',
        'rxgrp': '',
        'copay': ''
      }
    }
  },
  computed: {
    ...mapGetters(['idToken', 'accountId']),
    canShowDropZone () {
      this.dropzoneOptions.headers['Authorization'] = `Bearer ${this.idToken}`
      return (this.idToken !== '')
    },
    currentYear () {
      return new Date().getFullYear()
    },
    isDownloadEnabled () {
      return this.results.processed_values && this.results.processed_values.length > 0
    },
    buttonState () {
      if (this.currentState === 'upload') {
        return 'Upload & Process'
      } else if (this.currentState === 'processing') {
        return 'Uploading & Processing...'
      } else if (this.currentState === 'processed') {
        return 'Try another document'
      }
    },
    imageUrl () {
      return 'data:image/jpg;base64,' + this.results.image
    }
  },
  methods: {
    processFile () {
      if (this.currentState === 'upload') {
        var myDropzone = this.$refs.micpProcessDropZone.dropzone
        myDropzone.processQueue()
        myDropzone.on('complete', function (file) {
          myDropzone.removeFile(file)
        })
      } else {
        this.currentState = 'upload'
        this.isUploadEnabled = false
        this.isDropzoneBlank = false
        this.results = {}
        this.processedResults = {
          'provider': '',
          'name': '',
          'id': '',
          'group number': '',
          'pcp': '',
          'pcp phone': '',
          'rxbin': '',
          'rxpcn': '',
          'rxgrp': '',
          'copay': ''
        }
      }
    },
    processResponse (file, response) {
      this.currentState = 'processed'
      this.results = response
      let processedValues = Object.assign({}, this.processedResults)
      response.processed_values.forEach((pv, index) => {
        if (processedValues.hasOwnProperty(pv['key'])) {
          processedValues[pv['key']] = pv['text']
        }
      })
      this.processedResults = processedValues
      this.isUploadEnabled = true
      this.isDropzoneBlank = false
    },
    displayError (file, message, xhr) {
      Vue.toasted.show('Something went wrong! Please try again.', { icon: 'chain-broken', type: 'error' })
      this.currentState = 'upload'
      this.isUploadEnabled = false
      this.isDropzoneBlank = false
      this.results = {
        'provider': '',
        'name': '',
        'id': '',
        'group number': '',
        'pcp': '',
        'pcp phone': '',
        'rxbin': '',
        'rxpcn': '',
        'rxgrp': '',
        'copay': ''
      }
    },
    downloadJSON () {
      let processedData = this.results.processed_values.map((pv) => {
        return { key: pv.key, value: pv.text }
      })
      let fileName = this.results.image.split('/')[this.results.image.split('/').length - 1]
      fileName = fileName.split('_').slice(1).join('_')
      fileName = fileName.replace('-page-1.jpg', '')
      let mimeType = 'application/json'
      let fileType = '.json'
      let blob = new window.Blob([JSON.stringify(processedData)], { type: mimeType })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName.replace('.jpg', '') + fileType
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    onAddingFile () {
      var myDropzone = this.$refs.micpProcessDropZone.dropzone
      this.isUploadEnabled = myDropzone.files.length === 1
      this.isDropzoneBlank = false
    },
    sendingEvent (file, xhr, formData) {
      this.currentState = 'processing'
      this.isUploadEnabled = false
    },
    onExceedingMaxFiles () {
      Vue.toasted.show('Max files allowed is 1', { icon: 'chain-broken', type: 'error' })
    },
    onRemovingFile () {
      var myDropzone = this.$refs.micpProcessDropZone.dropzone
      if (this.currentState === 'upload') {
        this.isDropzoneBlank = myDropzone.files.length === 0
        this.isUploadEnabled = myDropzone.files.length === 1
      }
      if (myDropzone.getRejectedFiles().length > 0 &&
            myDropzone.getAcceptedFiles().length < myDropzone.options.maxFiles) {
        myDropzone.getRejectedFiles()[0]['status'] = 'queued'
        myDropzone.getRejectedFiles()[0]['previewTemplate']['classList'].remove('dz-error')
        myDropzone.getRejectedFiles()[0]['previewTemplate']['classList'].remove('dz-complete')
        myDropzone.getRejectedFiles()[0]['accepted'] = true
      }
    }
  }
}
</script>
<style type="scsss" scoped>
  .app-body {
    margin-top: 90px;
  }
  
  .dropzone {
    background-color: #eee;
    border: 1px solid #aaa;
    border-radius: .2rem;
    width: 80%;
    margin-left: 10%;
  }

  .upload-button {
    border-radius: 20px;
    padding: 10px 50px;
  }

  .upload-file-error {
    margin-left: 10%;
  }

  .download-button {
    border-radius: 8px;
    margin-bottom: -5px;
  }

  .process-results {
    height: 400px;
    overflow-y: scroll;
  }

  .processed-image {
    max-width: 100%;
  }

  .processed-value {
    border: 1px solid black;
  }

  .process-loading {
    width: 80%;
    margin-left: 10%;
  }

  .app-header {
    background: #fbfbfb;
  }

  .header-title {
    color: #4d4f52;
    font-weight: bolder;
    padding-top: 10px;
  }
  
  .mail-to {
    color: blue;
  }
  
  .contact-us {
    margin-left: 52%;
    margin-top: 1%;
  }
  
  .footer-style {
    padding: 12px;
    margin-top: -2%;
    background: #fbfbfb;
  }
</style>


// WEBPACK FOOTER //
// src/views/micp/micpDemo.vue